import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { FlashMessage } from '../components/comments/comment-flash-message';
import { Comment, CommentPostResponse } from '../models/comments/types';
import { fetchCommentById } from '../services/comment';
import { AxiosResponse } from 'axios';

type UseCommentFetcherProps = {
  contentId: number;
  commentId: string;
};

const useCommentFetcher = ({
  contentId,
  commentId,
}: UseCommentFetcherProps) => {
  const [comment, setComment] = useState<Comment>();
  const [isFetching, setIsFetching] = useState(true);
  const [message, setMessage] = useState<FlashMessage>();

  const { t } = useTranslation();

  const fetchComment = async () => {
    setIsFetching(true);

    try {
      const res = await fetchCommentById(contentId, commentId);
      handleFetchSuccess(res);
    } catch (err) {
      if (_.get(err, 'response')) {
        handleFetchFailure();
      } else {
        throw err;
      }
    }
  };

  const handleFetchSuccess = (res: AxiosResponse<CommentPostResponse>) => {
    const comment = {
      ...res.data.data.attributes,
      id: res.data.data.id,
    };

    setComment(comment);
    setIsFetching(false);
  };

  const handleFetchFailure = () => {
    setMessage({ text: t('comments.errors.fetch'), type: 'error' });
    setIsFetching(false);
  };

  useEffect(() => {
    void fetchComment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    comment,
    message,
    isFetching,
  };
};

export default useCommentFetcher;
